

















import Vue from "vue";
import GameProjects from "@/views/GameProjects.vue";
import OtherStuff from "@/views/OtherStuff.vue";
import Resume from "@/views/Resume.vue";
import Contact from "@/views/Contact.vue";

export default Vue.extend({
  name: "OnePage",
  components: {
    GameProjects,
    OtherStuff,
    Resume,
    Contact,
  },
  mounted: function () {
    this.$root.$emit("one-page-sections-ready");
  },
});
